import { DownloadButtonResponse } from '../../api-models';
import { HTTPMethod } from '../../types/enums';
import { AdapterInterface } from '../../types/global';
import BaseAdapter from './baseAdapter';

export default class PostCampaignHouseholdReferencesCsv extends BaseAdapter<DownloadButtonResponse> implements AdapterInterface {
  rawResponse: DownloadButtonResponse;

  async adaptResponse(request: { campaignCommunicationId: number }): Promise<string> {
    await this.fetchApiResponse('/api/campaign-household-references-csv', HTTPMethod.Post, { id: request.campaignCommunicationId });
    return this.rawResponse.signed_url;
  }
}
